import { DIY_DOCUMENT_VERFIFICATION_STATES } from "../post-inspection-diy/constant";

export const DIY_DOCUMENT_VERIFIED_STATE = [
    DIY_DOCUMENT_VERFIFICATION_STATES.VERIFIED,
    DIY_DOCUMENT_VERFIFICATION_STATES.APPROVED];

export const DIY_DOCUMENT_UNDER_VERIFICATION_STATE = [
    DIY_DOCUMENT_VERFIFICATION_STATES.VERIFICATION_PENDING,
    DIY_DOCUMENT_VERFIFICATION_STATES.UPLOADED,
    DIY_DOCUMENT_VERFIFICATION_STATES.PARTIALLY_MATCHED_CONFIRMED
];

export const DIY_DOCUMENT_VERIFICATION_FAILED_STATE = [
    DIY_DOCUMENT_VERFIFICATION_STATES.VERIFICATION_FAILED,
    DIY_DOCUMENT_VERFIFICATION_STATES.REJECTED];

export const CONSENT_OPTIONS = [
    {
        title: "Company-owned car. I am authorised by the company to sell it",
        key: "COMPANY_OWNED_CAR",
        eventLabel: "selection of company case"
    },
    {
        title: "Name on RC is wrong",
        key: "WRONG_RC",
        eventLabel: "selection of name on rc wrong"
    }
];
